(ns ncr.etc.modal
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [ncr.widgets.core :as w]
   [ncr.etc.reload :as rel]
   [uix.core.alpha :as uix]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   [lambdaisland.glogi :as log]
   [goog.events.EventType :as EventType]
   [goog.events.KeyCodes :as KeyCodes]))


(defn !modal* [{:keys [dialog placement args] :or {placement :inner}}]
  (let [ch (async/chan)]
    (ps/pub!
      [[::open placement] ch
       (if (vector? dialog)
         dialog
         (into [dialog] args))])
    ch))

(defn !modal [dialog & args]
  (!modal* {:dialog dialog :placement :inner :args args}))

(defn close! [result]
  (ps/pub! [::close result]))

(defn c-modal-container [tag]
  (let
    [state
     (rel/use-reload! ::c-modal
       (ps/sub-reducer-map! {:open? false}
         {[::open tag]
          (fn [state response dialog]
            (assoc state
              :response response
              :dialog dialog))

          ::close
          (fn [{:keys [response] :as state} result]
            (when state
              (when response
                (when (some? result)
                  (async/put! response result))
                (async/close! response)))
            {})}))]
    (get @state :dialog)))

(defn c-modal [{:keys [is-overflow-visible close-value] :as props} & body]
  [pf/c-modal
   (->
     {:has-no-body-wrapper true
      :aria-label "modal"}
     (merge props)
     (dissoc :is-overflow-visible :close-value)
     (merge
       {:is-open true
        :on-close
        #(close! close-value)}))

   [pf/c-modal-box-body
    (when is-overflow-visible
      {:style
       {:overflow :visible}})
    [w/c-error-boundary
     (into [:<>] body)]]])

(defn c-alert [props body]
  [c-modal
   (merge
     {:variant :small}
     props)
   body])

(defn- c-alert-ok-button []
  (let [ref (uix/ref nil)]
    (uix/with-effect [@ref] (when-let [el @ref] (.focus el)))
    [pf/c-button
     {:variant :primary
      :ref ref
      :on-click #(close! true)}
     "Ok"]))

(def button-variants
  {:ok
   [[c-alert-ok-button]]

   :ok-cancel
   [[c-alert-ok-button]
    [pf/c-button
     {:variant :link
      :on-click
      #(close! false)}
     "Cancel"]]})

(defn !alert [{:keys [actions-variant body] :as props}]
  (go
    (<!
      (!modal*
        {:dialog #'c-alert
         :placement :outer
         :args
         [(merge
            {:actions
             (get button-variants actions-variant (get button-variants :ok))}
            (dissoc props :body))
          body]}))))

(defn use-submit-form [modal-id ref submit]
  (let [element-ref (uix/ref)]

    (uix/with-effect [@ref]
      (when-let [el (and @ref (.getElementById js/document (name modal-id)))]
        (set! (.-tabIndex el) -1)
        (reset! element-ref el)))

    (w/use-event element-ref EventType/KEYDOWN
      (fn [e]
        (when
          (and
            (= (.-target e) (.-currentTarget e))
            (= KeyCodes/ENTER (.-keyCode e)))
          (submit e))))))
